import React from "react";
import { Phone, Calendar } from "lucide-react";
import { SITE } from "../lib/data";

export default function MobileStickyCTA() {
  return (
    <div
      data-testid="mobile-sticky-cta"
      className="lg:hidden fixed bottom-0 left-0 right-0 z-40 bg-white border-t border-pkash shadow-[0_-8px_24px_rgba(0,0,0,0.08)]"
    >
      <div className="grid grid-cols-2 gap-2 p-3">
        <a
          href="#programok"
          data-testid="mobile-sticky-programs"
          className="flex items-center justify-center gap-2 py-3 text-sm font-semibold tracking-[0.1em] uppercase text-pkcharcoal border border-pkcharcoal"
        >
          <Calendar className="w-4 h-4" strokeWidth={1.8} />
          Programok
        </a>
        <a
          href={SITE.phoneHref}
          data-testid="mobile-sticky-reservation"
          className="flex items-center justify-center gap-2 py-3 text-sm font-semibold tracking-[0.1em] uppercase text-white bg-pkred hover:bg-pkreddeep transition-colors"
        >
          <Phone className="w-4 h-4" strokeWidth={1.8} />
          Foglalás
        </a>
      </div>
    </div>
  );
}
